import { useEffect, useLayoutEffect, useRef, useState } from 'react'

/**
 * Returns request status and function response
 * @param {Function} f - async function
 * @param {Array} deps - dependency list, f function will activate only if the values in list change
 * @param {any} initialState of returned result value
 * @param {Function} cancel - effect cleanup
 * @return {Object} state - status and function response
 * @return {any} state.result - result of f function call
 * @return {string} state.status - request status
 */

export default function usePromise(f, deps = [], initialState = null, cancel = () => {}) {
  const [state, setState] = useState({ result: initialState, status: 'resolved' })
  const mounted = useRef(true)

  useLayoutEffect(() => {
    fetch()
  }, [...deps])

  useEffect(() => {
    return () => {
      mounted.current = false
      cancel()
    }
  }, [])

  async function fetch() {
    setState({ ...state, status: 'pending' })
    try {
      const result = await f()
      setState({ result, status: 'resolved' })
    } catch (result) {
      if (mounted.current) {
        setState({ result, status: 'rejected' })
      }
    }
  }

  return state
}
